(function () {
  'use strict';

  angular
    .module('crewingReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('crewingReport', {
        url: '/crewing-report',
        views : {
        	'crewingReportView' : {
        		templateUrl: 'crewing-report/views/crewing-report.tpl.html',
                controller: 'CrewingReportCtrl',
                controllerAs: 'crewingReport'
			}        	
        }
      });     
  }
}());
